export default {
	SET_GRAPHQL_VARIABLES(state, payload) {
		state.graphQlVariables = payload
	},
	SET_FILTER_WHERE(state, payload) {
		state.filter.where = payload
	}
}
